const api = "https://back.idbkoala.com/api/";
const apiImage = "https://back.idbkoala.com/storage/";
/* const api = "http://127.0.0.1:8000/api/";
const apiImage = "http://127.0.0.1:8000/storage/"; */
export default api;
export { apiImage };